import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-input/dist/index.module.css';
import Triangle from '@dtsl/icons/dist/icons/react/Triangle';
function NumberSpinner(props) {
  const {
    handleValueChange
  } = props;
  const numberStepperClass = classNames({
    [styles['sib-input__numberspinner']]: true,
    [styles['sib-input__numberspinner--inv']]: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "sib-input__numberspinner-container"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Incremental button",
    className: styles['sib-input__numberspinner'],
    onClick: e => handleValueChange(e, true)
  }, /*#__PURE__*/React.createElement(Triangle, {
    width: "8px",
    height: "8px",
    fill: "black",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": "Decremental button",
    className: numberStepperClass,
    onClick: e => handleValueChange(e, false)
  }, /*#__PURE__*/React.createElement(Triangle, {
    width: "8px",
    height: "8px",
    fill: "black",
    "aria-hidden": "true"
  })));
}
export default NumberSpinner;
NumberSpinner.propTypes = {
  handleValueChange: PropTypes.func
};